<script setup>
import Layout from "../../../Components/Shared/LayoutAdmin.vue";
import FruitForm from "../../../Components/Forms/FruitForm.vue";
import FruitCollectionPaginated from "../../../Components/Fruit/FruitCollectionPaginated.vue";
import ModalComponent from "../../../Components/Shared/ModalComponent.vue";
import ButtonComponent from "../../../Components/Shared/ButtonComponent.vue";
import { Link } from "@inertiajs/inertia-vue3";
import HeaderAdminComponent from "../../../Components/Shared/HeaderAdminComponent.vue";


import { ref } from "vue";
import useApi from "../../../Services/useApi";
import { Inertia } from "@inertiajs/inertia";
import useNotification from "../../../Services/useNotification";

const props = defineProps(["fruits", "current_sort", "current_direction"]);
const modalTitle = ref("Crear");
const api = useApi();
const notificate = useNotification()
const syncingPrices = ref(false)
// fruit
const fruitModal = ref(false);
const initFruit = {
    name: "",
    description: "",
    scientific_name: "",
    origin: "",
    seasonality: "",
    uses: "",
    nutritional_information: "",
    information_sources: "",
    price: "",
    supply: "",
    unit: "",
    featured: 0,
    image: "",
};
const fruitToCreate = ref(initFruit);
const createFruit = () => {
    fruitToCreate.value = initFruit;
    fruitModal.value = true;
    modalTitle.value = "Crear";
};
const editFruit = (fruit) => {
    fruitToCreate.value = fruit;
    fruitModal.value = true;
    modalTitle.value = "Editar";
};
const deleteFruit = (fruit) => {
    notificate.confirm("Seguro que quieres eliminar esta fruta ?",()=>{
        api.deleteFruit(fruit).then((response) => {
            console.log(response);
            notificate.success("Eliminado!");
            Inertia.reload();
        });
    })
};
const resetModals = () => {
    fruitModal.value = false;
};
const syncPrices = () => {
    if (syncingPrices.value) return

    syncingPrices.value = true
    api.syncFruitPrices()
        .then((summary) => {
            const reviewMessage = summary.skipped_anomalous > 0
                ? ` ${summary.skipped_anomalous} precio necesita revisión.`
                : ''
            const message = summary.updated > 0
                ? `${summary.updated} precios actualizados desde Google Sheets.${reviewMessage}`
                : `No hubo cambios. ${summary.unchanged} precios ya estaban actualizados.${reviewMessage}`
            Inertia.reload({
                preserveScroll: true,
                onFinish: () => notificate.success(message),
            })
        })
        .catch((error) => {
            notificate.error(error.response?.data?.message || 'No se pudieron sincronizar los precios.')
        })
        .finally(() => {
            syncingPrices.value = false
        })
};
</script>

<template lang="">
    <Layout>
        <HeaderAdminComponent title="Frutas"></HeaderAdminComponent>

        <div class="container mx-auto my-14 px-10">
            <ButtonComponent 
                content="Atrás" 
                :icon="'arrow_back_ios'"
                :link="'/admin'"
                type="2"
            />
            <div class="flex">
                <ButtonComponent 
                    content="Añadir nuevo producto" 
                    :icon="'add'"
                    :link="null"
                    type="0"
                    @click="createFruit" 
                />
                <ButtonComponent 
                    :content="syncingPrices ? 'Sincronizando...' : 'Sincronizar precios'"
                    icon="sync"
                    :link="null"
                    type="0"
                    :disabled="syncingPrices"
                    @click="syncPrices"
                />
            </div>

            <div class="my-10">
                <FruitCollectionPaginated
                    category="0"
                    :list="fruits"
                    :showActions="true"
                    :serverSorting="true"
                    :currentSort="current_sort"
                    :currentDirection="current_direction"
                    sortUrl="/admin/products"
                    @editItem="editFruit"
                    @deleteItem="deleteFruit"
                />
            </div>
        </div>
        <ModalComponent
            :title="modalTitle + ' fruta'"
            v-model="fruitModal"
            v-if="fruitModal"
        >
            <FruitForm @added="resetModals" :fruit="fruitToCreate" />
        </ModalComponent>
    </Layout>
</template>

<style lang="">
    
</style>
